import socketIOClient from 'socket.io-client'
import sailsIOClient from 'sails.io.js'
import { store } from './../state/index'

var io = sailsIOClient(socketIOClient)
// Additional Sails.io.js configuration
io.sails.url = process.env.VUE_API_BASE_URL
io.sails.autoConnect = true
io.sails.reconnection = true

io.install = function (Vue, options) {
  Vue.$io = io
  Vue.$socketConnected = false

  io.connect = function () {
    if (Vue.$io.socket) {
      try {
        Vue.$io.socket.disconnect()
      } catch (e) { }
    }

    Vue.$socketConnected = false
    let firstConnection = true

    const sock = Vue.$io.socket = Vue.$io.sails.connect()
    Vue.$io.socket.on('connect', () => {
      Vue.$socketConnected = true
      store.dispatch('Error/setWsStatus', {
        status: 200,
        modified: new Date().getTime()
      }, { root: true })

      // Rejoin network after websocket reconnection
      if (!firstConnection && store.state.User.user.lastNetworkId) {
        store.dispatch('User/selectNetwork', store.state.User.user.lastNetworkId)
        console.info('RECONNECTED WEBSOCKET TO NETWORK # ' + store.state.User.user.lastNetworkId)
      }

      firstConnection = false
    })
    Vue.$io.socket.on('disconnect', () => {
      Vue.$socketConnected = false
      store.dispatch('Error/setWsStatus', {
        status: 602,
        modified: new Date().getTime() - 15000
      }, { root: true })
    })
    Vue.$io.socket.on('pong', () => {
      store.dispatch('Error/setWsStatus', {
        status: 200,
        modified: new Date().getTime()
      }, { root: true })
    })
    Vue.$io.socket.on('error', () => {
      store.dispatch('Error/setWsStatus', {
        status: 602,
        modified: new Date().getTime()
      }, { root: true })
    })

    return new Promise((resolve, reject) => {
      const conn = () => {
        resolve()
        sock.off('connect', conn)
      }

      sock.on('connect', conn)
    })
  }
}

export default io



// WEBPACK FOOTER //
// ./src/sailsWebsocketPlugin.js